export default {
  emojiList: ["@happy", "@shocked", "@sad", "@cool"],
  quickChat: [
    "Hi",
    "Bye",
    "Gonna win",
    "Loser",
    "I am leaving",
    "Nice",
    "Un lucky",
    "Oh no",
    "Well played",
    "Yo",
  ],
  playStoreUrl: "https://play.google.com/store/apps/details?id=com.vubingo.www",
  developerUrl: "https://devbaji.github.io/",
};
